import { Box } from "@mui/material";
import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SellersProps } from "components/types";
import { removeAllSellers } from "store/auth/auth.slice";
import { AppState } from "store/types";
import SellerListItem from "./SellerListItem";
import { clearFilters } from "store/table/table.slice";

const SellersList = () => {
  const dispatch = useDispatch();
  const selectedSellers = useSelector(
    (state: AppState) => state.auth.selectedSellers
  );

  const extraSellersSelected = selectedSellers.filter(
    (item: SellersProps) => item.checked
  );

  const deleteAllItems = () => {
    dispatch(removeAllSellers());
    dispatch(clearFilters());
  };

  const sellersToDisplay = selectedSellers.filter(
    (item: SellersProps) => item.checked
  );

  const displaySellers = () => {
    if (selectedSellers?.length) {
      const isPresent = selectedSellers.find(
        (item: SellersProps) => item.checked
      );
      if (isPresent) return true;
    }
    return false;
  };

  return displaySellers() ? (
    <div
      style={{
        fontFamily: "Lato",
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "12px",
        lineHeight: "12px",
        display: "flex",
        alignItems: "center",
        margin: "12px 0",
        justifyContent: "end",
      }}
    >
      <div
        style={{
          backgroundColor: "rgba(25, 118, 210, 0.12)",
          borderRadius: "4px",
          display: "flex",
          flexDirection: "row",
          color: "#424242",
          gap: "5px",
          alignItems: "center",
          padding: "0px 8px",
        }}
      >
        <>
          <p>Seller: </p>
          {sellersToDisplay
            .slice(0, 3)
            .map(({ id, name, checked }: SellersProps, index: number) => {
              return (
                <SellerListItem
                  name={name}
                  index={index + 1}
                  id={id}
                  key={id}
                  checked={checked}
                />
              );
            })}
          {extraSellersSelected.length > 3 && (
            <span style={{ color: "#1976D2" }}>
              +{extraSellersSelected.length - 3} more
            </span>
          )}
        </>
      </div>
      <div>
        <p
          className="icon"
          onClick={deleteAllItems}
          style={{ color: "#0D47A1", margin: "0px 10px", cursor: "pointer" }}
        >
          [ Clear ]
        </p>
      </div>
    </div>
  ) : (
    <Box />
  );
};

export default SellersList;
